export default "__VITE_ASSET__c9iIyo$F__"